"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Button_1 = require("@material-ui/core/Button");
const Hidden_1 = require("@material-ui/core/Hidden");
const Typography_1 = require("@material-ui/core/Typography");
const styles_1 = require("@material-ui/core/styles");
const react_i18next_1 = require("react-i18next");
const ArcadeCurrency_1 = require("../card/ArcadeCurrency");
const package_1 = require("../package");
const styles = (theme) => (0, styles_1.createStyles)({
    userPointBalance: {
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        marginRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
            justifyContent: 'center',
            marginRight: 0
        }
    },
    arcadePointsSectionBtn: {
        marginLeft: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            marginLeft: 0,
            marginTop: theme.spacing()
        }
    },
    points: {
        display: 'flex',
        alignItems: 'center'
    },
    historyBtn: {
        display: 'flex',
        alignItems: 'center'
    }
});
const ArcadePointsSection = ({ classes, balance, onClick, navigateToHistory, disableHistoryButton, disableBalance }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: classes.userPointBalance }, { children: [disableBalance ? null : ((0, jsx_runtime_1.jsxs)(Typography_1.default, Object.assign({ color: 'textPrimary', variant: "h5", className: classes.points, component: 'div' }, { children: [balance ? balance.toPointsFormat() : 0, (0, jsx_runtime_1.jsx)(ArcadeCurrency_1.default, { color: 'secondary', size: 22 })] }))), (0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ variant: 'contained', size: 'medium', color: 'primary', onClick: onClick, className: classes.arcadePointsSectionBtn }, { children: [t('arcade.button.buy'), (0, jsx_runtime_1.jsx)(ArcadeCurrency_1.default, { color: 'secondary', size: 16 })] })), disableHistoryButton ? null : ((0, jsx_runtime_1.jsxs)(Button_1.default, Object.assign({ variant: 'text', size: 'large', color: 'secondary', onClick: navigateToHistory, className: classes.historyBtn, "aria-label": 'Go to history page' }, { children: [(0, jsx_runtime_1.jsx)(package_1.Icon, { iconType: 'material', iconName: 'history', className: classes.historyIcon }), (0, jsx_runtime_1.jsx)(Hidden_1.default, Object.assign({ mdUp: true }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "overline", color: "secondary" }, { children: t('store.history') })) }))] })))] })));
};
exports.default = (0, styles_1.withStyles)(styles)(ArcadePointsSection);
//# sourceMappingURL=ArcadePointsSection.js.map